// Tiny pub/sub for a "condense the chrome" signal. The content-layout page emits
// it from its inner scroll; the header (nav pill), the floating rail, and the
// page title bar subscribe so they can hide/compact and free up the content area.
let listeners = [];
let current = false;

export const subscribeCondense = (fn) => {
  listeners.push(fn);
  try { fn(current); } catch (e) { /* noop */ }
  return () => { listeners = listeners.filter((l) => l !== fn); };
};

export const setCondense = (val) => {
  const next = !!val;
  if (next === current) return;
  current = next;
  listeners.forEach((fn) => { try { fn(next); } catch (e) { /* noop */ } });
};
